import { Component } from "@angular/core";
import {
    FormBuilder,
    FormGroup,
    Validators,
    ReactiveFormsModule,
} from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";

import { AuthService } from "../../../core/services/auth.service";
import { ForgotPasswordRequest } from "../../../core/models/auth.model";

@Component({
    selector: "app-forgot-password",
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterLink,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatIconModule,
    ],
    templateUrl: "./forgot-password.html",
    styleUrls: ["./forgot-password.scss"],
})
export class ForgotPasswordComponent {
    forgotPasswordForm: FormGroup;
    error: string = "";
    loading: boolean = false;
    currentYear: number = new Date().getFullYear();
    showSuccessMessage: boolean = false;
    submittedEmail: string = "";

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private router: Router
    ) {
        this.forgotPasswordForm = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
        });
    }

    onSubmit(): void {
        if (this.forgotPasswordForm.valid) {
            this.loading = true;
            this.error = "";

            const request: ForgotPasswordRequest = {
                email: this.forgotPasswordForm.value.email,
            };

            this.authService.forgotPassword(request).subscribe({
                next: () => {
                    this.submittedEmail = request.email;
                    this.showSuccessMessage = true;
                    this.loading = false;
                },
                error: (err) => {
                    this.error = err.message || "An error occurred. Please try again.";
                    this.loading = false;
                },
            });
        }
    }

    goToLogin(): void {
        this.router.navigate(["/login"]);
    }
}
